import React, { useState, useEffect } from "react";
// api gére les requetes vers l'api avec axios et la variable d'environnement;
import api from "../../api";
import { Navigate } from "react-router-dom";
import UseTitle from "../../components/useTitle";
import "./SkillTemplateNew.scss";

const SkillTemplateNew = () => {
  // Définition du titre de la page
  UseTitle("Création d'une compétence");

  const [name, setName] = useState();
  const [nickname, setNickname] = useState();
  const [description, setDescription] = useState();
  const [valueStart, setValueStart] = useState(0);
  const [attributes, setAttributes] = useState([]);
  const [forBattle, setForBattle] = useState(false);
  const [isActiveDefault, setIsActiveDefault] = useState(true);

  const [allAttributes, setAllAttributes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [messageError, setMessageError] = useState([]);

  const [redirectTo, setRedirectTo] = useState();

  const checkSkillTemplate = () => {
    const errors = [];
    if (!name) errors.push("Veuillez renseigner le nom");

    if (!nickname) errors.push("Veuillez renseigner le surnom");

    const valueStartNumber = Number(valueStart);
    if (valueStart === "" || isNaN(valueStartNumber))
      errors.push("Veuillez renseigner la valeur de base");
    else if (valueStartNumber < 0 || valueStartNumber > 50)
      errors.push("La valeur de base doit être comprise entre 0 et 50");

    if (attributes.length === 0)
      errors.push("Veuillez ajouter au moins un attribut");

    if (errors.length > 0) {
      setIsFormValid(false);
      setMessageError(errors);
    } else {
      setIsFormValid(true);
      setMessageError([]);
    }
  };

  const handleAttributeChange = (selectedAttribute) => {
    const attributeId = selectedAttribute.id;
    setAttributes((prevAttributes) =>
      prevAttributes.some((attribute) => attribute.id === attributeId)
        ? prevAttributes.filter((attribute) => attribute.id !== attributeId)
        : [...prevAttributes, selectedAttribute]
    );
  };

  const handleNew = () => {
    if (!isFormValid) return;

    setIsLoading(true);

    const attributeIds = attributes.map((attribute) => attribute.id);

    const skill_template_data = {
      name: name,
      description: description,
      attributes_ids: attributeIds,
      value_start: valueStart,
      nickname: nickname,
      for_battle: forBattle,
      is_active_default: isActiveDefault,
    };

    api
      .post(`/skilltemplate/`, skill_template_data)
      .then((response) => {
        setRedirectTo(`/skill/${response.data.id}`);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    setIsLoading(true);
    api
      .get(`/attributes/`)
      .then((response) => {
        setAllAttributes(response.data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    checkSkillTemplate();
  }, [name, nickname, valueStart, attributes]);

  if (redirectTo) {
    return <Navigate to={redirectTo} replace={true} />;
  }

  return (
    <>
      <div className="skill-template-new">
        {isLoading && <p>Chargement...</p>}
        {!isLoading && (
          <>
            <h1>Nouvelle compétence</h1>
            <form
              className="skill-template-new-form"
              onSubmit={(e) => {
                e.preventDefault();
                handleNew();
              }}
            >
              <div>
                <label htmlFor="name">Nom </label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
              <div>
                <label htmlFor="nickname">Abréviation </label>
                <input
                  type="text"
                  name="nickname"
                  id="nickname"
                  value={nickname}
                  onChange={(e) => setNickname(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="description">Description </label>
                <textarea
                  name="description"
                  id="description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="valueStart">Valeur de départ </label>
                <input
                  type="number"
                  name="valueStart"
                  id="valueStart"
                  value={valueStart}
                  min={0}
                  max={50}
                  onChange={(e) => setValueStart(e.target.value)}
                />
              </div>
              <div>
                <label>Attributs</label>
                {allAttributes.map((attribute) => (
                  <div key={attribute.id}>
                    <input
                      type="checkbox"
                      name="attributes"
                      id={attribute.id}
                      checked={attributes.some(
                        (attributeToCheck) =>
                          attributeToCheck.id === attribute.id
                      )}
                      onChange={() => handleAttributeChange(attribute)}
                    />
                    <label htmlFor={attribute.id}>{attribute.full_name}</label>
                  </div>
                ))}
              </div>
              <div>
                <label htmlFor="forBattle">Pour la battaille </label>
                <input
                  type="checkbox"
                  name="forBattle"
                  id="forBattle"
                  checked={forBattle}
                  onChange={(e) => setForBattle(e.target.checked)}
                />
              </div>
              <div>
                <label htmlFor="isActiveDefault">Est activé par defaut </label>
                <input
                  type="checkbox"
                  name="isActiveDefault"
                  id="isActiveDefault"
                  checked={isActiveDefault}
                  onChange={(e) => setIsActiveDefault(e.target.checked)}
                />
              </div>
              <div className="buttons">
                <button
                  className={!isFormValid ? "bt disebled" : "bt"}
                  type="submit"
                  disabled={!isFormValid}
                >
                  Valider
                </button>
                <button
                  className="bt"
                  type="button"
                  onClick={() => setRedirectTo("/skill/")}
                >
                  Annuler
                </button>
              </div>
            </form>
            {messageError.length > 0 && (
              <div className="errors">
                {messageError.map((messageError, index) => (
                  <div className="error" key={index}>
                    {messageError}
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default SkillTemplateNew;
